jQuery(document).ready(function($) {
    const sidebar = $('.sidebar');
    if (!sidebar.length) return;

    const ul = sidebar.children('ul');
    const collapseMenuWrapper = sidebar.find('.collapse-menu-wrapper');

    const onResize = () => {
        // ul has a max height of window height - top offset - collapse menu height - collapse menu bottom offset
        const windowHeight = $(window).height();
        const topOffset = ul.offset().top;
        const collapseMenuHeight = collapseMenuWrapper.outerHeight();
        const collapseMenuBottomOffset = parseInt(collapseMenuWrapper.css('bottom'));
        const maxHeight = windowHeight - (topOffset + collapseMenuHeight + collapseMenuBottomOffset);

        const sidebarHeight = ul.height();

        collapseMenuWrapper.toggleClass('static', sidebarHeight > maxHeight);

        ul.children('li').each((i, li) => {
            // For each li detect in there is 160px of space below it
            const rect = li.getBoundingClientRect();
            const spaceBelowIsEnough = window.innerHeight - (rect.top + rect.height) > 100;

            $(li).toggleClass('space-below', spaceBelowIsEnough);
        });

    }
    $(window).resize(onResize);
    onResize();
})

function sidebar_click_open(elm) {
    const $ = jQuery.noConflict();
    const a = $(elm);
    return !$('.sidebar-button-wrapper').is(':visible');
}
function desktop_toggle_sidebar() {
    const $ = jQuery.noConflict();
    const body = $('body');
    body.toggleClass('sidebar-collapsed');
    const value = body.hasClass('sidebar-collapsed') ? 1 : 0;

    $.post('/save-collapse', {value});
}
